import { createSelector } from '@reduxjs/toolkit';
import { stringifyQuote } from '@ui/features/quote-builder/state/utilities/stringify-quote';
import { RootState } from '@ui/store';

import { WritableQuoteBuilderStateType } from '../../types/state';

export const selectFormIsDirty = createSelector(
  [(state: RootState) => state.quoteBuilder],
  (state) => {
    if (!state) {
      return false;
    }

    return isFormDirty(state);
  },
);

export const isFormDirty = (state: WritableQuoteBuilderStateType) => {
  const { currentServerData, pendingServerData } = state;

  if (!(currentServerData || pendingServerData)) {
    return false;
  }

  const serializedState = stringifyQuote(state);

  if (pendingServerData) {
    return pendingServerData !== serializedState;
  }

  return currentServerData !== serializedState;
};
